<script>
	export let defaultValue;
	export let id;
	export let label;
	export let name;
	export let placeholder;
	export let required = false;
	export let type = 'text';
	export let value;
</script>

<label for={id}>{@html label}</label>
{#if (type === 'email')}
	<input bind:value {placeholder} {defaultValue} {id} {name} {required} type="email">
{:else if (type === 'number')}
	<input bind:value {placeholder} {defaultValue} {id} {name} {required} type="number">
{:else}
	<input bind:value {placeholder} {defaultValue} {id} {name} {required} type="text">
{/if}